import { gql } from "@apollo/client";

export const GET_DIRECCION_PACIENTE_BY_ID = gql`
query evaluacionById($idEvaluacion: Int!) {
    evaluacionById(idEvaluacion: $idEvaluacion) {
        evaluacion{
            idPaciente
            idEvaluacion
            idLugarRI
            idPacienteNavigation{
                nombre
                apellido
                codSAPPaciente
                latitud
                longitud
            }
            evaluacionDireccion {
                idTipoDireccion
                direccion
                localidad
                provincia
                codigoPostal
                observacion
            }
        }
    }
}`;

export const adaptPacienteActual = (evaluacion = {}) => {
  const { idPacienteNavigation, evaluacionDireccion } = evaluacion;
  const direccionDelPaciente = evaluacionDireccion?.find((direccion) => direccion?.idTipoDireccion === 1);
  const direccionInstitucion = evaluacionDireccion?.find((direccion) => direccion?.idTipoDireccion === 2);
  return {
    idEvaluacion: evaluacion?.idEvaluacion,
    idLugarRI: evaluacion?.idLugarRI,
    codigoSAP: idPacienteNavigation?.codSAPPaciente,
    nombre: idPacienteNavigation?.nombre + ' ' + idPacienteNavigation?.apellido,
    latitud: idPacienteNavigation?.latitud,
    longitud: idPacienteNavigation?.longitud,
    direccionDelPaciente: direccionDelPaciente !== null && direccionDelPaciente !== undefined && !!direccionDelPaciente?.direccion ? {
      direccion: direccionDelPaciente?.direccion,
      localidad: direccionDelPaciente?.localidad,
      provincia: direccionDelPaciente?.provincia,
      codigoPostal: direccionDelPaciente?.codigoPostal,
      observacion: direccionDelPaciente?.observacion,
      latitud: idPacienteNavigation?.latitud,
      longitud: idPacienteNavigation?.longitud,
    } : null,
    direccionInstitucion: direccionInstitucion !== null && direccionInstitucion !== undefined && !!direccionInstitucion?.direccion ? {
      direccionInstitucion: direccionInstitucion?.direccion,
      localidadInstitucion: direccionInstitucion?.localidad,
      provinciaInstitucion: direccionInstitucion?.provincia,
      codigoPostalInstitucion: direccionInstitucion?.codigoPostal,
      habitacion: direccionInstitucion?.observacion
    } : null
  };
};